@if (loading || !card) {
<div class="kpi fade-in">
  <div class="skel skel--icon"></div>
  <div class="skel skel--val"></div>
  <div class="skel skel--label"></div>
  <div class="skel skel--sub"></div>
</div>
} @else {
<div class="kpi fade-in" [id]="card.id ?? null">
  <div class="kpi__icon" [style.background]="card.iconBg">
    <mat-icon [style.color]="card.iconColor">{{ card.icon }}</mat-icon>
  </div>
  @if (card.valueLoading) {
  <div class="skel skel--val"></div>
  } @else {
  <div class="kpi__val" [class.kpi__val--sm]="card.smallValue"><bdi>{{ card.value }}</bdi></div>
  }
  <div class="kpi__label">{{ card.label }}</div>
  @if (card.scope) {
  <app-scope-chip class="kpi__scope" [scope]="card.scope"></app-scope-chip>
  }
  @if (card.loading) {
  <div class="skel skel--sub"></div>
  } @else {
  <div class="kpi__sub">{{ card.sub }}</div>
  }
  @if (card.updatedDaily) {
  <div class="kpi__fresh" title="{{'GUI.dashboard.tooltips.refreshed' | translate}}">
    <mat-icon>schedule</mat-icon>
    {{ 'GUI.dashboard.labels.as of today' | translate }}
  </div>
  }
  @if (card.viewAllLink) {
  <a class="kpi__viewall" [routerLink]="[card.viewAllLink]">
    {{ 'GUI.dashboard.labels.view all' | translate }}
    <mat-icon>chevron_right</mat-icon>
  </a>
  }
  @if (card.periodSelect === 'billing') {
  <select class="kpi__period-select" #billingKpiSelect (change)="onBillingChange(billingKpiSelect.value)">
    <option value="today" [selected]="billingPeriod === 'today'">{{ 'GUI.dashboard.selects.today' | translate }}
    </option>
    <option value="week" [selected]="billingPeriod === 'week'">{{ 'GUI.dashboard.selects.this week' | translate }}
    </option>
    <option value="month" [selected]="billingPeriod === 'month'">{{ 'GUI.dashboard.selects.this month' | translate }}
    </option>
  </select>
  } @else if (card.periodSelect === 'storage') {
  <select class="kpi__period-select" #storageKpiSelect (change)="onStorageChange(storageKpiSelect.value)">
    <option value="today" [selected]="storagePeriod === 'today'">{{ 'GUI.dashboard.selects.today' | translate }}
    </option>
    <option value="week" [selected]="storagePeriod === 'week'">{{ 'GUI.dashboard.selects.this week' | translate }}
    </option>
    <option value="month" [selected]="storagePeriod === 'month'">{{ 'GUI.dashboard.selects.this month' | translate }}
    </option>
  </select>
  } @else {
  <div class="kpi__trend" [class]="'kpi__trend--' + card.trendTone">{{ card.trend }}</div>
  }
</div>
}